/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import moment from 'moment'

import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../../_metronic/partials/widgets'
import api from '../../utils/Api'
import {numberFormat} from '../../utils/Functions'
import { Bar } from 'react-chartjs-2';
import {Container, Row, Col, Form, Button, InputGroup,Card, Table} from 'react-bootstrap'
import DatePicker from '../../components/DatePicker'
import {reactSelectValue, reactSelectMultiValue} from '../../utils/Helper'
import _ from 'lodash'
import Select from 'react-select';
import autocolors from 'chartjs-plugin-autocolors';
import ChartDataLabels from 'chartjs-plugin-datalabels';

function fillRanking(data: any) {
  // Step 1: Create an array of prices with their original indices
  const indexedPrices = data.map((price: any, index: number) => ({ price, index }));

  // Step 2: Sort the array by price in descending order
  indexedPrices.sort((a: any, b: any) => b.price - a.price);

  // Step 3: Assign ranks based on the sorted array
  const ranks = new Array(data.length);
  indexedPrices.forEach((item: any, rank: number) => {
    ranks[item.index] = rank + 1;  // Rank starts from 1 (for highest price)
  });

  return ranks
}

const IncomeByBranch = ({branches}: any) =>{

  const [chart, setChart] = useState<any>({datasets: [], labels: []})
  const [filter, setFilter] = useState<any>({startDate: new Date, endDate: new Date, type: 'sales'})
  useEffect(()=>{
    if (!filter.startDate || !filter.endDate) return

    api.request('dashboard/sales-by-category', (r,s)=>{
      setChart(r)
    }, {
      ...filter,
      startDate: moment(filter.startDate).toISOString(),
      endDate: moment(filter.endDate).toISOString(),
    })
  }, [filter])

  const data = {
    labels: chart.labels.slice(0, 10), // X-axis labels
    datasets: chart.datasets.slice(0, 10),
  };

  return  (
    <Row className="dashboard__item-container">
      <Col xs={12} className="d-flex justify-content-end align-items-center">
        <Select
          className="me-5 w-150px mb-3"
          classNamePrefix="react-select"
          options={[{
            label: 'ยอดขาย',
            value: 'sales'
          }, {label: 'จำนวนเคส', value: 'count'}]}
          name="type"
          defaultValue={{
            label: 'ยอดขาย',
            value: 'sales'
          }}
          onChange={(opt)=>{
            setFilter({...filter, type: opt?.value})
          }}
        />
        <Select
          className="mb-3 me-3"
          classNamePrefix="react-select"
          options={branches}
          placeholder="All branches"
          isClearable
          onChange={(v: any)=>{
            setFilter({...filter, branchId: v?.value || ''})
          }}
          value={reactSelectValue(branches, filter.branchId)}
        />
        <div className="dashboard__date">
          <DatePicker onChange={([startDate, endDate]: any)=>{
            setFilter({...filter, startDate, endDate})
          }}
          startDate={filter.startDate}
          endDate={filter.endDate}
          dateFormat="dd/MM/yyyy"
          selectsRange
          />
        </div>
      </Col>
      <Col sm={12} md={10}>
        <h3 className="text-center">Sales by category</h3>
        <Bar data={data} plugins={[autocolors, ChartDataLabels]} options={{
          layout: {
              padding: {
                  //left: 50,
                  right: 50,
                  //top: 50,
                  //bottom: 50
              }
          },
          plugins: {
            colors: {
              enabled: true
            },
            legend: {
              display: false // Disable the legend completely
            },
            autocolors: {
             enabled: true,
             mode: 'data',
             offset: 0
           },
           datalabels: {
             anchor: 'end',
             align: 'end',
             formatter: function(value, context) {
               return numberFormat(Math.round(value), true, ''); // Show the actual value
             }
           }
         },
         indexAxis: 'y'
        }} />
      </Col>
      <Col sm={12} md={2}>
        <Table bordered responsive className="dashboard__table--income-by-branch dataTable">
          <thead>
            <tr>
              <th>Branch</th>
              <th>{filter.type==='sales'?'ยอดขาย':'จำนวนเคส'}</th>
            </tr>
          </thead>
          <tbody>
            { chart.labels.map((code: string, index: number)=>(
              <tr key={index}>
                <td style={{width: 150}}>{code}</td>
                <td>{numberFormat(Math.round(chart.datasets[0]?.data[index] || 0), true, '0')}</td>
              </tr>
            ))
            }
          </tbody>
        </Table>
      </Col>
    </Row>

  )
}


export default IncomeByBranch
